import { useState } from 'react';
import { T } from '../lib/design-tokens';

interface GlassCardProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  hover?: boolean;
  className?: string;
  onClick?: () => void;
}

export function GlassCard({
  children,
  style = {},
  hover = false,
  className = '',
  onClick,
}: GlassCardProps) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      className={className}
      style={{
        background: hover && hovered ? T.glassHover : T.glass,
        border: `1px solid ${hover && hovered ? T.cream12 : T.glassBorder}`,
        borderRadius: 14,
        backdropFilter: 'blur(12px)',
        transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)',
        transform: hover && hovered ? 'translateY(-2px)' : 'none',
        boxShadow: hover && hovered ? '0 8px 32px rgba(0,0,0,0.3)' : 'none',
        cursor: onClick ? 'pointer' : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
